export default __webpack_public_path__ + "static/media/about.dea7b647.jpg";